<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('spending.breadcrumb')" :title="$t('spending.title')">
      <div class="list__buttons">
        <label for="file_spending" class="list__import-button">
          <input
            @change="importSpending(index)"
            type="file"
            name="file_spending"
            :id="`file_spending`"
            accept=".csv"
          />
          Import
        </label>
        <div class="list__import-button" @click="exportSpending()">Export</div>
        <div class="list__import-button" @click="openAlertModal()">Send Spend Alerts</div>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.facebook_account_id" placeholder="FB ID" />
        </div>
        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.day_from" :format="'DD.MM.YYYY'" />
        </div>
        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.day_to" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
      </div>

      <div class="list">
        <div v-if="spendingList.length">
          <CustomTable
            v-if="spendingList.length"
            :data="spendingList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
            :noSortColumn="tableOptions.noSortColumn"
            :name="'spending'"
          >
          </CustomTable>
          <div class="pagination">
            <Pagination
              :maxPage="spending.lastPage"
              :page="page"
              :urlList="'SPENDING_LIST'"
              :totalItem="spending.total"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No found by this parameter.</div>
      </div>
    </ContentContainer>

    <MainModal v-if="alertModal" :on-close="closeAlertModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">Send Spend Alerts?</div>
        <div class="list__filter-items center">
          <div class="list__filter-item">
            <b>from: </b>
            <DatePicker v-model="alert_from" :format="'DD.MM.YYYY'" />
          </div>
          <div class="list__filter-item">
            <b>to: </b>
            <DatePicker v-model="alert_to" :format="'DD.MM.YYYY'" />
          </div>
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="closeAlertModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="sendAlert" :button-cancel="true">SEND</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import userApi from "~/api/user";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "SpendingList",
  metaInfo() {
    return {
      title: this.$t("spending.metaTitle"),
    };
  },
  data() {
    return {
      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "id",

      detailModal: false,
      chosenLead: null,

      alertModal: false,
      alert_from: null,
      alert_to: null,

      filterData: {
        facebook_account_id: "",
        day_to: null,
        day_from: null,
      },
      isFilter: false,

      tableOptions: {
        deletedKeys: ["null"],
        noSortColumn: ["amountSpent", "facebookAccountId", "buyer_name", "team_name"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },

          {
            from: "facebookAccountId",
            to: "FB Account Id",
          },
          {
            from: "buyer_name",
            to: "Buyer",
          },
          {
            from: "team_name",
            to: "Team",
          },
        ],
        customOrder: [
          "id",
          "facebookAccountId",
          "amountSpent",
          "day",
          "buyer_name",
          "team_name",
          "null",
        ],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    ModalError,
    DatePicker,
    MainModal,
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("users", ["error", "loadingProcess", "spending", "spendingList"]),
    page() {
      return +this.$route.params.page;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList() {
      let url = `?page=${this.page}&perPage=20`;
      if (this.orderSort.length) {
        url =
          url +
          `&sortField=${this.orderSort}&sortDest=${
            this.directionSort ? "asc" : "desc"
          }&with[]=buyer`;
      }

      if (this.isFilter) {
        const data = {
          parameters: {},
        };

        console.log(this.filterData, "filter");

        if (this.filterData.facebook_account_id.length > 1) {
          data.parameters.facebook_account_id = this.filterData.facebook_account_id;
        }

        if (this.filterData.day_to) {
          data.parameters.day_to = this.filterData.day_to;
        }

        if (this.filterData.day_from) {
          data.parameters.day_from = this.filterData.day_from;
        }

        userApi
          .getSpendingListFilter(url, data)
          .then((res) => {
            this.$store.commit("users/setLoading", false);
            const spending = res.data?.items?.data || [];

            for (let i = 0; spending.length > i; i++) {
              if (
                spending[i].buyer &&
                typeof spending[i].buyer === "object" &&
                !Array.isArray(spending[i].buyer)
              ) {
                spending[i].buyer_name = spending[i].buyer.email;

                if (spending[i].buyer.teams.length > 0) {
                  spending[i].team_name = spending[i].buyer.teams[0].name;
                }
              }
            }

            this.$store.commit("users/setSpendingList", spending);
            this.$store.commit("users/setSpending", res.data.items);
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("users/setLoading", false);
            this.isFilter = false;
            this.getList();
          });
      } else {
        this.$store.dispatch("users/getSpendingList", url);
      }
    },

    filterList() {
      this.isFilter = true;
      if (this.page > 1) {
        this.$router.push({
          path: ROUTE.SPENDING_LIST.replace(":page", 1),
        });
      } else {
        this.getList();
      }
    },
    filterListReset() {
      this.isFilter = false;
      this.filterData.facebook_account_id = "";
      this.filterData.day_from = null;
      this.filterData.day_to = null;
      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    closeAlertModal() {
      this.alertModal = false;
      this.alert_from = null;
      this.alert_to = null;
    },
    openAlertModal() {
      this.alertModal = true;
    },
    sendAlert() {
      this.$store.commit("users/setLoading", true);
      const data = {};
      if (this.alert_from) {
        data.date_from = moment(this.alert_from).format("YYYY-MM-DD");
      } else {
        this.$store.commit("users/setLoading", false);
        alert("Date from required!!!");
        return;
      }
      if (this.alert_to) {
        data.date_to = moment(this.alert_to).format("YYYY-MM-DD");
      }
      userApi
        .alertSpending(data)
        .then((res) => {
          alert("Alert success!");
          this.closeAlertModal();
        })
        .catch((error) => {
          alert("Alert Error!!");
        })
        .finally(() => {
          this.$store.commit("users/setLoading", false);
        });
    },
    importSpending() {
      const file = document.querySelector(`input[name="file_spending"]`).files[0];
      let data = new FormData();
      data.append("file", file);
      this.$store.commit("users/setLoading", true);

      userApi
        .importSpending(data)
        .then((res) => {
          alert(this.$t("spending.uploadOk"));
          this.getList();
        })
        .catch((error) => {
          alert(this.$t("spending.uploadError"));
        })
        .finally(() => {
          this.$store.commit("users/setLoading", false);
        });
    },
    exportSpending() {
      const data = {
        parameters: {},
      };

      if (this.isFilter) {
        if (this.filterData.facebook_account_id.length > 1) {
          data.parameters.facebook_account_id = this.filterData.facebook_account_id;
        }

        if (this.filterData.day_to) {
          data.parameters.day_to = this.filterData.day_to;
        }

        if (this.filterData.day_from) {
          data.parameters.day_from = this.filterData.day_from;
        }
      }
      userApi
        .exportSpending(data)
        .then((res) => {
          console.log(res);

          const blob = new Blob([res.data]);
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "spending_export.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();

          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.log(error);
          alert(this.$t("spending.downloadError"));
        })
        .finally(() => {
          this.$store.commit("users/setLoading", false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr 1fr !important;
}

.list {
  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__buttons {
    display: flex;
  }

  &__filter-items {
    display: flex;
    justify-content: center;
    padding: 20px 0 10px;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }

  &__import-button {
    display: flex;
    background: #3c2a1e;
    padding: 10px;
    border-radius: 5px;
    width: fit-content;
    color: #fff;
    cursor: pointer;
    margin-left: 10px;

    input {
      visibility: hidden;
      width: 0;
      height: 0;
    }
  }
}
</style>
